import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { DateTime } from 'luxon'
import { useQuery, gql } from '@apollo/client'
import CoachProfileAnalyticsDisplay from './coach-profile-analytics-display'

const COACH_PROFILE_ANALYTICS = gql`
  query GetCoachAnalytics(
    $coachName: String!
    $startDate: String
    $endDate: String
  ) {
    GetCoachAnalytics(
      coachName: $coachName
      startDate: $startDate
      endDate: $endDate
    ) {
      impressions
      clicks
      widgetImpressions
      widgetClicks
    }
  }
`

const CoachAnalytics = ({ coachProfile }) => {
  const { firstName, lastName } = coachProfile
  const coachName = `${firstName} ${lastName}`

  const aMonthAgo = DateTime.local().minus({ months: 1 })
  const today = DateTime.local()

  const [startDate, setStartDate] = useState(aMonthAgo)
  const [endDate, setEndDate] = useState(today)

  const { loading, error, data } = useQuery(COACH_PROFILE_ANALYTICS, {
    variables: {
      coachName,
      startDate: startDate.toISODate(),
      endDate: endDate.toISODate(),
    },
  })

  const analytics = !loading ? data && data.GetCoachAnalytics : {}
  return (
    <CoachProfileAnalyticsDisplay
      {...analytics}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      startDate={startDate}
      endDate={endDate}
      loading={loading}
      error={error}
    />
  )
}

CoachAnalytics.propTypes = {
  coachProfile: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
}

export default CoachAnalytics
